import {createSelector} from 'reselect';

const selectGateways = (state) => state.gateways;

const makeSelectGatewaysData = () => createSelector(selectGateways, (gatewaysState) => gatewaysState.gatewaysData);

const makeSelectGatewaysList = () => createSelector(makeSelectGatewaysData(), (gatewaysData) => gatewaysData?.items);

const makeSelectCurrentGateway = () => createSelector(selectGateways, (gatewaysState) => gatewaysState.currentGateway);

const makeSelectGatewayTypes = () =>
    createSelector(makeSelectGatewaysData(), (gatewaysData) => gatewaysData?.gatewayTypes);

const makeSelectGatewaySortableColumns = () =>
    createSelector(makeSelectGatewaysData(), (gatewaysData) => gatewaysData?.sortableColumns);

export {
    makeSelectGatewaysData,
    makeSelectGatewaysList,
    makeSelectCurrentGateway,
    makeSelectGatewayTypes,
    makeSelectGatewaySortableColumns,
};
